import React from "react";
import PropTypes from 'prop-types';
import RenderComponents from "../RenderByType/RenderComponents";

const VerticalArray = ({column, path}) => {
    return (
        column.map((item, i) => {
            return (
                <RenderComponents
                    path={`${path}.children.${i}`}
                    parentPath={path}
                    parentLength={column.length}
                    type={item.type}
                    item={item}
                    index={i}
                />
            )
        })
    )
};

export default VerticalArray;

VerticalArray.propTypes = {
    column: PropTypes.array,
    path: PropTypes.string
};

VerticalArray.defaultProps = {
    column: []
};